import React, { Component } from 'react';
import './MakeModelFilter.css';
import { Select, Icon } from 'antd';
import { observer, inject } from 'mobx-react';

import compact from 'lodash/compact';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import isEmpty from 'lodash/isEmpty';

@inject('carsStore', 'translationsStore')
@observer
export default class MakeModelFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMakes: null,
      selectedModels: null
    };
  }

  changeMakes = selectedMakes => {
    this.setState({ selectedMakes });
  };

  changeModels = selectedModels => {
    this.setState({ selectedModels });
  };

  removeModelsForMake = make => {
    const newSelectedModels = (this.state.selectedModels || []).map(JSON.parse).filter(selectedModel => !selectedModel[make]);
    this.setState({ selectedModels: newSelectedModels.map(JSON.stringify), selectedMakes: this.state.selectedMakes.filter(el => make !== el) }, () => {
      this.props.carsStore.applyFilters();
    });
  };

  removeModelsFromResult = model => {
    this.setState({ selectedModels: this.state.selectedModels.filter(el => model !== el) }, () => {
      this.props.carsStore.applyFilters();
    });
  }

  reset = () => {
    new Promise(resolve => {
      this.changeMakes();
      this.changeModels();
      resolve();
    }).then( () => {
      this.props.carsStore.applyFilters();
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      //props.status === false means the filter is not present. If here means the filter has been removed
      this.resetMakeAndModels();
    }
    if (prevState.selectedMakes !== this.state.selectedMakes) {
      this.buildFilterFunctions((this.state.selectedMakes || []).map(codiceMarca => ({ [codiceMarca]: '' })), (this.state.selectedModels || []).map(JSON.parse));
      //this.buildFilterFunctions((this.state.selectedMakes || []), (this.state.selectedModels || []));
    }
    if (prevState.selectedModels !== this.state.selectedModels) {
      this.buildFilterFunctions((this.state.selectedMakes || []).map(codiceMarca => ({ [codiceMarca]: '' })), (this.state.selectedModels || []).map(JSON.parse));
      //this.buildFilterFunctions((this.state.selectedMakes || []), (this.state.selectedModels || []));
    }
  }

  resetMakeAndModels() {
    this.setState({
      selectedMakes: null,
      selectedModels: null,
      uniqueModelsGroupedByMake: null
    });
  }

  buildFilterFunctions(makes = [], makesWithModel = []) {
    if (makes.length === 0 && makesWithModel.length === 0) {
      delete this.props.carsStore.appliedFilters.models;
    } else {

      const modelsGroupedByMake = groupBy(makes.concat(makesWithModel), value => Object.keys(value)[0]);
      const uniqueModelsGroupedByMake = mapValues(modelsGroupedByMake, value => value.reduce((acc, value) => compact(acc.concat(Object.values(value)[0])), []));

      this.setState({ uniqueModelsGroupedByMake });

      this.props.carsStore.appliedFilters.models = uniqueModelsGroupedByMake;
    }
  }

  selectionDescription = () =>
    Object.keys(this.state.uniqueModelsGroupedByMake)
      .map(codiceMarca => {
        let descrizioneMarca = (this.props.carsStore.filters.makes.find(make => make.codiceMarca === codiceMarca) || '').descrizione;
        let descrizioneModelli = this.state.uniqueModelsGroupedByMake[codiceMarca]
          .map(codiceModello => this.props.carsStore.filters.models.find(model => model.codiceModello === codiceModello).descrizione)
          .join(', ');
        return `${descrizioneMarca} ${descrizioneModelli ? `[${descrizioneModelli}]` : ''}`;
      })
      .join(', ');

  render() {
    const { translationsStore, carsStore, status } = this.props;
    const { selectedMakes, selectedModels } = this.state;

    return (
      <div className="MakeModelFilter" id="MakeModelFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.makeModel')}
          <span>
            {!isEmpty(this.state.uniqueModelsGroupedByMake) && status !== false && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="selected" title={this.selectionDescription()}>
                  {this.selectionDescription()}
                </div>
                <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.reset} />
              </div>
            )}
          </span>
        </div>

        <div className="selectContainer">
          <Select
            maxTagCount={4}
            onDeselect={this.removeModelsForMake}
            mode="multiple"
            value={selectedMakes || []}
            getPopupContainer={() => document.getElementById('MakeModelFilter')}
            onChange={this.changeMakes}
            optionFilterProp="description"
          >
            {carsStore.filters.makes.map(make => (
              <Select.Option key={make.codiceMarca} description={make.descrizione}>
                {make.descrizione}
              </Select.Option>
            ))}
          </Select>
          <Select
            maxTagCount={2}
            onDeselect={this.removeModelsFromResult}
            value={selectedModels || []}
            getPopupContainer={() => document.getElementById('MakeModelFilter')}
            disabled={carsStore.filters.models.length === 0}
            onChange={this.changeModels}
            mode="multiple"
            optionFilterProp="description"
          >
            {carsStore.filters.makesWithModels
              .filter(make => {
                if (selectedMakes && selectedMakes.length > 0) {
                  return selectedMakes.includes(make.codiceMarca);
                }
                return true;
              })
              .map(make => (
                <Select.OptGroup key={make.codiceMarca} label={make.descrizione}>
                  {make.models.map(model => (
                    <Select.Option key={model.codiceModello} value={`{"${make.codiceMarca}":"${model.codiceModello}"}`} description={`${make.descrizione} ${model.descrizione}`}>
                      {make.descrizione} {model.descrizione}
                    </Select.Option>
                  ))}
                </Select.OptGroup>
              ))}
          </Select>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/MakeModelFilter/MakeModelFilter.js